@tailwind base;
@tailwind components;
@tailwind utilities;

:host {
  display: block;
  @apply tw-py-16;
  @apply tw-px-4;
  font-family: Inter, PT Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif;
  
  
}

accordion-section {

  // h2, h3 {
  //   //font-size: 1.49625rem;
  //   @apply text-2xl;
  //   @apply font-bold;
  // }
  
  .section-content {
    @apply tw-pb-8;
    &:empty {
      display:none;
    }
  }



  button[aria-expanded=true] {
    color:#507DAF;
    
  }
  // $breakpoint-tablet: 768px;
  .collapsable-panel {
    ul {
      padding:0;
      li {
        svg {
          min-width:16px;
        }
        @apply tw-rounded-none;
        // @media (min-width: $breakpoint-tablet) {
        //   display: inline-block;
        //   background-color: #E4E4E4;
        //   @apply tw-rounded-full;
        // }        
      }
    }
  }

  
}
